module.exports = __webpack_public_path__ + "static/media/zola_registry_app_icon.155367a8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/footer/zola_registry_app_icon.png
 ** module id = 2139
 ** module chunks = 44
 **/